import moment from 'moment';

export default {
    methods: {
        timeAgo(date, format = 'MMM D') {
            if (this.isLessThanSevenDays(date)) {
                return moment(date).fromNow();
            }

            return moment(date).format(format);
        },

        tooltipDateFormat(date) {
            if (this.isLessThanSevenDays(date)) {
                return moment(date).format('ll h:mm a');
            }

            return moment(date).format('h:mm a');
        },

        formatDate(date, format = 'LL') {
            return moment(date).format(format);
        },

        formatEmailDate(date) {
            // TODO: add more rules to formate email date
            return moment(date).format('MMM D');
        },

        timeFormat(date) {
            return moment(date).format('h:mm a');
        },

        formatTime(dateString) {
            return this.timeFormat(moment(dateString));
        },

        formatDateAgo(dateString) {
            return this.timeAgo(moment(dateString));
        },

        dateSegment(date, hasTime) {
            const today = moment().format('MM/DD/YYYY');
            const yesterday = moment().subtract(1, 'day').format('MM/DD/YYYY');
            const tomorrow = moment().add(1, 'day').format('MM/DD/YYYY');
            const momentDate = moment(date);
            const givenDate = momentDate.format('MM/DD/YYYY');
            let dateString;

            if (givenDate === today) {
                dateString = this.$i18nInstance.t('global.time.today');
            } else if (givenDate === yesterday) {
                dateString = this.$i18nInstance.t('global.time.yesterday');
            } else if (givenDate === tomorrow) {
                dateString = this.$i18nInstance.t('global.time.tomorrow');
            } else {
                dateString = momentDate.format('LL');
            }

            if (hasTime) {
                return `${dateString}, ${momentDate.format('h:mm a')}`;
            }

            return dateString;
        },

        upNextComparison(activity1, activity2) {
            const now = moment();
            const date1 = moment(activity1.startDate);
            const date2 = moment(activity2.startDate);

            if (date1.isBefore(now) && date2.isAfter(now)) {
                return 1;
            }

            if (date1.isAfter(now) && date2.isBefore(now)) {
                return -1;
            }

            if (date1.isSame(date2, 'minutes')) {
                const actionType1 = activity1.actionType;
                const actionType2 = activity2.actionType;

                if (actionType1 === actionType2) {
                    return moment(activity1.createdDate).diff(moment(activity2.createdDate));
                }

                if (actionType1 === 'appointment') {
                    return -1;
                }

                if (actionType2 === 'appointment') {
                    return 1;
                }

                return 0;
            }

            return date1 - date2;
        },

        timeNow() {
            return this.encodeTimeForTimePicker(new Date());
        },

        today() {
            return new Date();
        },

        encodeTimeForTimePicker(date) {
            const newDate = new Date(date);
            const rawMinutes = newDate.getMinutes();
            const rawHours = newDate.getHours();

            const minutes = rawMinutes >= 30 ? '00' : '30';
            let hours = (rawMinutes >= 30 ? rawHours + 1 : rawHours).toString();

            hours = hours.length === 1 ? `0${hours}` : hours;

            return `${hours}${minutes}`;
        },

        isLessThanSevenDays(date) {
            const momentDate = moment(date);
            const diff = moment().diff(momentDate, 'days');

            if (diff < 7) {
                return true;
            }

            return false;
        },
    },
};
